import React from 'react'

interface ChatEditIconProps {
  size?: number
  color?: string
  className?: string
}

const ChatEditIcon: React.FC<ChatEditIconProps> = ({
  size = 24,
  color = '#FFFFFF',
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      {/* 编辑笔图标 */}
      <path
        d="M13.2568 7.35355C13.4521 7.15829 13.7686 7.15829 13.9639 7.35355L14.8247 8.21436C15.02 8.40962 15.02 8.7262 14.8247 8.92146L8.61227 15.1339C8.52778 15.2184 8.41583 15.2698 8.29669 15.2789L7.01647 15.3764C6.89429 15.3857 6.79255 15.284 6.80186 15.1618L6.89936 13.8816C6.90844 13.7624 6.95988 13.6505 7.04436 13.566L13.2568 7.35355Z"
        fill={color}
      />
      {/* 底部线条 */}
      <path
        d="M7 17H17"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default ChatEditIcon
